<template>
  <div id="search-surveys" class="wrap">
    <div class="fixed-container">
      <div id="header-card">
        <div class="card-head-container">
          <div class="card-title-container">
            <h4>Discover {{ itemType }}s</h4>
          </div>
        </div>
        <div class="w-100 header-card-content">
          <b-form-input v-model="searchTerm" placeholder="Search by name" class="text-input"></b-form-input>
          <hr class="divider" />
          <b-dropdown v-if="!isTemplateEdit" id="dropdown-2" text="Search by Status" class="text-input" menu-class="w-100">
            <b-dropdown-item-button 
              v-for="(filter, filterName) in statusFilters" :key="filterName" 
              @click.native.capture.stop="toggleSelectedStatusFilter(filter)" 
              :class="{ 'dropdown-active': selectedStatusFilter === filter }" 
            >
              {{ filterName }}
            </b-dropdown-item-button>
          </b-dropdown>
          <b-dropdown id="dropdown-1" text="Search by Tag" class="text-input" menu-class="w-100">
            <b-dropdown-group v-for="(tagNames, category) in tags" :key="category" :header="category">
              <b-dropdown-item-button 
                v-for="tag in tagNames" :key="tag" 
                @click.native.capture.stop="toggleSelectedTag(tag)" 
                :class="{ 'dropdown-active': selectedTags.includes(tag) }" 
              >
                {{ tag }}
              </b-dropdown-item-button>
            </b-dropdown-group>
          </b-dropdown>
          <div class="d-flex flex-wrap justify-content-start tag-selector">
            <b-button @click="clearAllTags" class="clear-all-button">Clear All Filters</b-button>
            <b-button v-for="element in selectedTags" :key="element" class="tag-button-chosen" @click="removeSelectedTag(element)">
              {{ element }}
            </b-button>
          </div>
          <hr class="divider" />
          <div class="d-flex justify-content-end">
            <div id="gridview" v-if="!gridView" @click="setGridView" class="clickable-icon">
              <span class="icon-text">Grid View</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grid"
                viewBox="0 0 16 16">
                <path
                  d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z" />
              </svg>
            </div>
            <div id="listview" v-if="gridView" @click="setListView" class="clickable-icon">
              <span class="icon-text">List View</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list"
                viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
              </svg>
            </div>
            <!-- <div id="sort" class="clickable-icon">
              <span class="icon-text">Sort By</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-sort-up"
                viewBox="0 0 16 16">
                <path
                  d="M3.5 12.5a.5.5 0 0 1-1 0V3.707L1.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L3.5 3.707V12.5zm3.5-9a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z" />
              </svg>
            </div> -->
          </div>
          <div v-if="isTemplateEdit" class="add-template-container">
            <b-button class="add-new-template" @click="addTemplate">Add New Template</b-button>
          </div>
        </div>
      </div>
    </div>
    
    <GridViewSurvey 
      v-if="gridView" 
      :surveys="searchSurvey" 
      :mode="actionType" 
      :isSurveyAdmin="isSurveyAdmin" 
      @open-approval="openApproval" 
      @open-preview="openPreview" 
      @open-delete="openDelete" 
      @select-item="selectItem" 
    />
    <ListViewSurvey 
      v-if="!gridView" 
      :surveys="searchSurvey" 
      :mode="actionType" 
      :isSurveyAdmin="isSurveyAdmin" 
      @open-approval="openApproval" 
      @open-preview="openPreview" 
      @open-delete="openDelete" 
      @select-item="selectItem" 
    />

    <b-modal v-model="isApprovalVisible" id="approve-confirm" size="xl" centered hide-footer>
      <template #modal-title>
        <span class="h3 mb-0">Confirm Approval</span>
        <!-- or inline: <span style="font-size:1.75rem; margin:0">Confirm Approval</span> -->
      </template>
      <h3>{{ itemType }} requested for manual review</h3>
      <h4>Reason for the request:</h4>
      <b-form-textarea
        v-model="selectedSurvey.reviewRequest"
        rows="5"
        class="mb-3 no-highlight"
        readonly
        tabindex="-1"
      ></b-form-textarea>
      <h2 style="margin-bottom:0">Questions:</h2>
      <div class="review-box" style="margin-top:0">
					<PreviewSurvey :questions="selectedSurvey.questions" />
			</div>
      <div class="d-flex justify-content-between">
        <!-- Disapprove Button -->
        <b-button variant="danger" @click="openDisapproveModal" class="mt-auto btn-alt">
          Disapprove
        </b-button>
        <!-- Approve Button -->
        <b-button variant="success" @click="approveSurvey(selectedSurvey)" class="mt-auto btn-default">
          Approve
        </b-button>
      </div>  
    </b-modal>

    <b-modal v-model="isDisapproveVisible" id="disapprove-feedback" title="Provide Feedback" centered hide-footer>
      <p>Please provide feedback for why this {{ itemType.toLowerCase() }} is disapproved:</p>
      <b-form-textarea
        v-model="feedbackText"
        placeholder="Enter your feedback here..."
        rows="5"
        class="mb-3"
      ></b-form-textarea>
      <div class="d-flex justify-content-between">
        <b-button class="btn-alt" @click="closeDisapproveModal">
          Cancel
        </b-button>
        <b-button class="btn-default" @click="disapproveSurvey(selectedSurvey)">
          Submit Feedback
        </b-button>
      </div>
    </b-modal>

    <b-modal v-model="isPreviewVisible" v-if="!isApprovalVisible && !isDisapproveVisible" id="view-survey" :title="'Preview ' + itemType" size="xl" hide-footer>
      <template #modal-title>
        <div class="modal-title-container">
          <div class="modal-title">{{ selectedSurvey.name }}</div>
          <div :title="editMessage">
            <b-button v-if="isTemplateEdit || isSurveyDev || isSurveyAdmin" :disabled="!!editMessage" @click="editSurvey(selectedSurvey)" class="edit-button">
              Edit
            </b-button>

            <b-button
              v-if="isSurveyAdmin && selectedSurvey.status === 3"
              class="needs-approval-button needs-approval-icon" 
              @click="openApproval(selectedSurvey)"
              title="Click here to approve"
              variant="light"
              size="sm"
            >
              <b-icon icon="exclamation-triangle-fill" style="color: #fc7727;" />
            </b-button>
          </div>
        </div>
      </template>
      <ViewTemplate :template="selectedSurvey" />
      <div v-if="isTemplateSelect" class="use-template-footer">
        <b-button @click="selectItem(selectedSurvey)" class="edit-button">
          Use this template
        </b-button>
      </div>
    </b-modal>

    <b-modal v-model="isDeleteVisible" id="delete-confirm" title="Confirm Delete" centered hide-footer>
      <p>Are you sure you want to delete this {{ itemType.toLowerCase() }}?</p>
      <div class="d-flex justify-content-between">
        <b-button class="btn-default"  @click="isDeleteVisible = false">
          Cancel
        </b-button>
        <b-button class="btn-alt" @click="deleteSurvey(selectedSurvey)">
          Delete
        </b-button>
      </div>
    </b-modal>

    <b-modal v-model="isSuccessVisible" id="delete-success" title="Delete Success" centered hide-footer>
      <p>{{ itemType }} has been successfully deleted!</p>
      <div class="d-flex justify-content-center">
        <b-button class="btn-default" @click="isSuccessVisible = false">
          OK
        </b-button>
      </div>
    </b-modal>
  <OnboardingWrapper /></div>
</template>

<script>
import GridViewSurvey from "./survey-views/GridViewSurvey.vue";
import ListViewSurvey from "./survey-views/ListViewSurvey.vue";
import ViewTemplate from "../survey-create/search-templates-components/ViewTemplate.vue";
import Template from "../../Firestore/Template";
import Notifications from "../../Firestore/Notifications";
import PreviewSurvey from "../survey-create/PreviewSurvey.vue";
import OnboardingWrapper from '../onboarding/OnboardingWrapper.vue';
import { onboardingService } from '@/services/OnboardingService';
import { initializePageOnboarding } from '@/services/onboardingConfigs';
export default {
  name: "SearchSurveys",
  components: {
    GridViewSurvey,
    ListViewSurvey,
    ViewTemplate, // Replace?
    PreviewSurvey,
    OnboardingWrapper
  },
  props: {
    mode: { // One of "survey-edit", "template-edit", or "template-select"
      type: String,
      default: "",
    },
  },
  data() {
    return {
      userId: window.localStorage.getItem("userId"),
      userType: window.localStorage.getItem("userType") ? parseInt(window.localStorage.getItem("userType")) : -1, // 0: Tester, 1: Developer, 2: Admin
      unsubscribe: null,
      tags: {
        "Mechanics": ["Playability", "Combat", "Mechanics", "Indicators", "Environment", "Skill Tree", "Enemies", "Puzzles"],
        "Usability": ["UI", "Controls", "Audio", "Dialogue", "Help", "Text", "Usability", "Menus" ],
        "Systems": ["Map", "Customization", "Goals", "Navigation", "Tutorial", "Onboarding", "Objectives", "Level Design"],
        "Design": ["Character", "Story", "NPC", "Art", "Music"],
        "Performance": ["Balance", "Pacing", "Skill", "Immersion", "Difficulty", "Fun"],
      },
      statusFilters: {
        "All": () => true,
        "New": x => x.status === 0 && !x.feedback,
        "Revision Requested": x => x.status === 0 && x.feedback,
        "Pending Approval": x => x.status === 3,
        "Pending Publish": x => x.status === 4,
        "Published": x => x.status === 1,
        "Archived": x => x.status === 2,
        "Flagged": x => x.status === 5,
      },
      searchTerm: "",
      selectedTags: [], // Array that dynamically changes to hold info for displaying selected tags
      selectedStatusFilter: null,
      gridView: true,
      surveys: [],
      selectedSurvey: {},
      isApprovalVisible: false,
      isPreviewVisible: false,
      isDeleteVisible: false,
      isSuccessVisible: false,
      isDisapproveVisible: false,
      feedbackText: "", // Stores feedback text from the admin
    };
  },
  computed: {
    isSurveyDev() {
      return this.mode === "survey-edit" && this.userType === 1;
    },
    isSurveyAdmin() {
      return this.mode === "survey-edit" && this.userType === 2;
    },
    isTemplateEdit() {
      return this.mode === "template-edit" && this.userType === 2;
    },
    isTemplateSelect() {
      return this.mode === "template-select" && this.userType === 1;
    },
    itemType() {
      if (this.isSurveyDev || this.isSurveyAdmin) {
        return "Survey";
      } else if (this.isTemplateEdit || this.isTemplateSelect) {
        return "Template";
      } else {
        return "";
      }
    },
    actionType() {
      if (this.isSurveyDev || this.isSurveyAdmin || this.isTemplateEdit) {
        return "edit";
      } else if (this.isTemplateSelect) {
        return "select";
      } else {
        return "";
      }
    },
    editMessage() {
      if (this.isSurveyDev || this.isSurveyAdmin) {
        if (this.selectedSurvey.status === 1) {
          return "Published surveys cannot be edited";
        } else if (this.selectedSurvey.status === 2) {
          return "Archived surveys cannot be edited";
        } else if (this.isSurveyDev && this.selectedSurvey.status === 3) {
          return "Surveys pending approval cannot be edited";
        } else if (this.selectedSurvey.status === 4) {
          return "Approved surveys cannot be edited";
        }
      }
      return "";
    },
    searchSurvey() {
      return this.surveys.filter(survey =>
        survey.name.toLowerCase().includes(this.searchTerm.toLowerCase()) &&
        this.selectedTags.every(tag => survey.tags.includes(tag)) && 
        (!this.selectedStatusFilter || this.selectedStatusFilter(survey))
      );
    },
  },
mounted() {
  if (!this.isTemplateSelect) {
    window.localStorage.removeItem("gameId");
  }

  this.clearAllTags();
  this.getAllSurveys();
  console.log("[SearchSurveys]");
console.log("mode =", this.mode);
console.log("userType =", this.userType);
console.log("isSurveyDev =", this.isSurveyDev);
  // ✅ Developer Survey onboarding
  if (this.isSurveyDev) {
    this.$nextTick(() => {
      initializePageOnboarding(
        'searchSurvey',
        this.userType,
        onboardingService,
        this.$store
      );
    });
  }
},

  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }
  },
  methods: {
    setSurveys(res) {
      if (res.success) {
        this.surveys = res.data;
      }
    },
    getAllSurveys() {
      // Grab all surveys from backend here, set result to this.surveys
      if (this.isSurveyDev) {
        this.unsubscribe = Template.watchSurveysByDevID(this.userId, this.setSurveys);
      } else if (this.isSurveyAdmin) {
        this.unsubscribe = Template.watchAllSurveys(this.setSurveys);
      } else if (this.isTemplateEdit || this.isTemplateSelect) {
        this.unsubscribe = Template.watchAllTemplates(this.setSurveys);
      }
    },
    toggleSelectedTag(tagName) {
      if (!this.selectedTags.includes(tagName)) {
        this.selectedTags.push(tagName);
      } else {
        this.removeSelectedTag(tagName);
      }
    },
    removeSelectedTag(tagName) {
      const index = this.selectedTags.indexOf(tagName);
      this.selectedTags.splice(index, 1);
    },
    clearAllTags() {
      this.selectedStatusFilter = this.statusFilters["All"];
      this.selectedTags = [];
    },
    toggleSelectedStatusFilter(filter) {
      if (this.selectedStatusFilter !== filter) {
        this.selectedStatusFilter = filter;
      } else {
        this.selectedStatusFilter = null;
      }
    },
    setGridView() {
      this.gridView = true;
    },
    setListView() {
      this.gridView = false;
    },
    addTemplate() {
      this.$router.push({
        name: "editsurvey",
        params: {
          mode: "template",
          itemId: "new",
        },
      });
    },
    openApproval(survey) {
      this.selectedSurvey = survey;
      this.isApprovalVisible = true;
    },
    openPreview(survey) {
      this.selectedSurvey = survey;
      this.isPreviewVisible = true;
    },
    openDelete(survey) {
      this.selectedSurvey = survey;
      this.isDeleteVisible = true;
    },
    selectItem(survey) {
      this.selectedSurvey = survey;
      this.$emit("select-item", this.selectedSurvey);
    },
    deleteSurvey(survey) {
      if (this.isSurveyDev || this.isSurveyAdmin) {
        Template.deleteSurvey(survey.sID).then(() => {
          this.isSuccessVisible = true;
        });
      } else if (this.isTemplateEdit) {
        Template.deleteTemplate(survey.sID).then(() => {
          this.isSuccessVisible = true;
        });
      }
      this.isDeleteVisible = false;
    },
    approveSurvey(survey) {
      // If pending approval, set to approved
      if (this.isSurveyAdmin && survey.status === 3) {
        Template.setSurveyStatusRemoveFeedback(survey.sID, 4);
        Template.setSurveyStatusRemoveReviewRequest(survey.sID, 4);
        Template.clearFlaggedQuestions(survey.sID);
        Notifications.deleteNotificationsBySurvey(survey.sID)
          .catch(e => console.log(e));
      }
      this.isApprovalVisible = false;
    },
    openDisapproveModal() {
      this.isApprovalVisible = false; 
      this.isDisapproveVisible = true; 
    },
    closeDisapproveModal() {
      this.isDisapproveVisible = false;
      this.feedbackText = ""; 
    },
    disapproveSurvey(survey) {
      if (!this.feedbackText.trim()) {
      alert("Feedback is required to disapprove.");
      return;
      }

      if (this.isSurveyAdmin && survey.status === 3) {
        Template.setSurveyStatusAndFeedback(survey.sID, 0, this.feedbackText);
        Notifications.deleteNotificationsBySurvey(survey.sID)
          .catch(e => console.log(e));
      }

      this.isDisapproveVisible = false; // Close the modal
      this.feedbackText = ""; // Clear feedback text
    },
    editSurvey(survey) {
      this.$router.push({
        name: "editsurvey",
        params: {
          mode: this.itemType.toLowerCase(),
          itemId: survey.sID,
        },
      });
    },
  },
};
</script>

<style scoped>
::before,
::after {
  box-sizing: inherit;
}

.wrap {
  width: 100%;
  margin: 0;
  padding: 1rem 1rem;
  height: 100%;
  display: flex;
  flex-direction: row;
  overflow: clip;
  justify-content: space-evenly;
  align-items: start;
  gap: 0 1rem;
}

.fixed-container {
  background-color: #EEEEEE;
  width: 35%;
  max-width: 606px;
  min-width: 285px;
  height: 100%;
}

.add-new-template {
  background-color: #fc7727 !important;
  color: #fff;
  margin-top: auto;
  border: none;
  border-radius: 5px !important;
  padding: 0.25rem 0.5rem;
  width: 100%;
  height: fit-content;
  align-items: center;
  justify-content: center;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);
}

.add-new-template:hover {
  background-color: #ff8e4d !important;
}

div.template-container {
  width: 65%;
  min-width: 200px;
  margin: 0 auto;
  justify-content: space-evenly;
  flex-direction: row;
  padding: 0 0;
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto !important;
  overflow-x: clip;
  max-height: 100%;
}

div.template-container .card-container div {
  margin-top: 0;
}

#header-card {
  margin: 0 0;
  width: 100%;
  height: 100%;
  min-height: 270px;
  padding: 1rem 2rem;
  background-color: white;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.55rem 0;
}

.header-card-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 0.55rem 0;
}

.card-head-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 0;
}

.card-title-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

h4.survey-title {
  font-size: large;
  padding-right: 50px;
  margin-top: 2px !important;
  margin-bottom: 5px !important;
  max-height: 1.4rem !important;
  color: #FF7222 !important;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

h6.survey-title {
  margin-top: 2px !important;
  margin-bottom: 5px !important;
  max-height: 1.4rem !important;
  padding-right: 50px;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.template-buttons {
  min-width: fit-content;
}

.text-input.form-control {
  background-color: #eee !important;
  border-radius: 10px !important;
  color: #8e8e8e !important;
  border: none;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-bottom: 0.5rem;
}

.adv-search-title {
  font-weight: bold !important;
  color: #FF7222 !important;
}

#search-surveys div.tag-selector .btn.clear-all-button {
  background-color: #e5e5e5 !important;
  color: #000 !important;
  border-radius: 5px;
}

div.tag-selector {
  max-height: 50%;
  overflow-y: auto;
}

div.tag-selector .btn.clear-all-button:active,
div.tag-selector .btn.clear-all-button:hover {
  background-color: #5c636a !important;
  color: #fff !important;
}

div.tag-selector .btn.clear-all-button,
#search-surveys .btn.tag-button-chosen,
label.tag-button-child {
  border-radius: 10px;
  border: none;
  font-size: 90% !important;
  font-weight: bold !important;
  padding: 0.5rem 0.5rem;
  margin: 3px 0.5rem 3px 0rem;
}

label.tag-button-child {
  background-color: #DB3360 !important;
  color: white;
  height: 35px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  justify-content: center;
  align-items: center;
}

#search-surveys .btn.tag-button-chosen {
  background-color: #DB3360 !important;
  color: white !important;
}

#search-surveys .btn.tag-button-chosen:hover {
  padding: 0.5rem 0.6rem;
  background-color: #E64A74 !important;
}

#search-surveys .btn.tag-button-chosen {
  color: white !important;
}

.divider {
  margin: 0.3rem 0;
}

header.dropdown-header {
  margin: 0 0.3rem;
  padding: 0 0.2rem;
  background-color: #F4BECC;
  border-radius: 5px;
  color: white;
  user-select: none;
}

.btn.dropdown-toggle {
  color: #8e8e8e !important;
  text-align: start;
  background-color: #eee !important;
  border: none !important;
}

#dropdown {
  padding: 6px 12px;
}

#dropdown-content {
  display: none;
}

#dropdown:active,
#dropdown:focus #dropdown-content {
  display: block;
}

div.card-head-container .nav-button {
  margin: 0 0.3rem;
  padding: 0.2rem 0.8rem;
}

div.add-template-container {
  margin-top: auto;
  margin-bottom: 5px;
}

div.clickable-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 5px;
}

div.clickable-icon:hover {
  cursor: pointer;
  background-color: #cecece;
}

span.icon-text {
  font-style: italic;
  color: #000;
  margin-right: 5px;
  font-size: small;
}

.btn-default {
  background-color: #fc7727 !important;
  border: none;
}

.btn-default:hover {
  background-color: #ff8e4d !important;
}

.btn-alt {
  background: #DB3360 !important;
  border: none;
}

button.btn-alt:hover {
  background: #DB3360 !important;
}

.btn.template-nav-button {
  background: #FF7222 !important;
  margin: 5px;
  border: 0 !important;
  padding: 0.3rem 0.5rem;
}

.modal-title-container {
  display: flex;
}

.use-template-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}

.modal-title {
  color: #FF7222 !important;
  font-weight: bold;
}

.delete-button {
  background: #FF7222 !important;
  margin: 5px;
  border: 0 !important;
  position: relative;
}

.delete-button:hover {
  background: #ff8e4d !important;
}

.delete-button:focus,
.delete-button:active {
  background: #FF7222 !important;
}

.edit-button {
  background-color: #fc7727 !important;
  margin-left: 8px;
  border: none;
  padding: 0.25rem 0.75rem;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);
}

.edit-button:hover {
  background-color: #ff8e4d !important;
}

.close-button {
  background: #6c757d !important;
  margin: 5px;
  border: 0 !important;
  position: relative;
}

.close-button:hover {
  background: #848d94 !important;
}

.close-button:focus,
.close-button:active {
  background: #6c757d !important;
}

.confirm-modal-text {
  color: black !important;
  margin: 0.5rem;
}

>>> .btn.dropdown-toggle {  
  background-color: #fc7727 !important;
  color: #fff;
  border: none;
  border-radius: 5px !important;
  width: 100%;
  height: fit-content;
  align-items: center;
  justify-content: center;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);
}

>>> .add-new-template:hover {
  background-color: #ff8e4d !important;
}

>>> ul.dropdown-menu {
  width: 100%;
  max-height: 30rem;
  overflow: auto;
  border: none;
  box-shadow: 0 4px 6px -2px grey;
}

>>> li.dropdown-active > button.dropdown-item {
  background-color: #007BFF;
  color: #FFFFFF;
}

>>> .close {
  padding: 0px;
  margin-left: auto;
  margin-right: 2px;
  border: none;
  background: none;
  font-size: 24px;
}

.review-box {
  background-color: white;
  border-radius: 15px;
  padding: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin: 2rem auto;
  width: 100%;
}

.no-highlight {
  user-select: none;
  -webkit-user-select: none;
}
.no-highlight:focus {
  outline: none !important;
  box-shadow: none !important;
}

@media screen and (min-height: 900px) {
  .inner-surveys-container:has(div div.wrap) {
    overflow: hidden;
  }
}

@media screen and (max-height: 900px) {
  .inner-surveys-container:has(div div.wrap) {
    overflow: auto;
  }
}

@media screen and (min-width: 1785px) {
  div.template-container {
    width: calc(100% - 606px);
  }
}

.needs-approval-button {
  position: absolute;
  top: 10px;
  right: 43px;
  background-color: transparent;
  color: #fc7727;
  border: none;
  box-shadow: none;
  font-size: 1.8rem; /* Icon size */
  padding: 0;
  cursor: pointer;
}

.needs-approval-button:hover {
  color: #ff8e4d !important;
}

@media screen and (max-width: 992px) {
  .wrap {
    flex-direction: column;
    overflow: auto;
    gap: 1rem;
    justify-content: flex-start;
  }

  .fixed-container {
    width: 100%;
    max-width: none;
    height: auto;
  }

  div.template-container {
    width: 100%;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/survey-dashboard/SearchSurveys.vue